import React, { useState, useEffect, useMemo } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  IconButton,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const CreateEditPollModal = ({
  open,
  handleClose,
  handleSubmit,
  eventData,
}) => {
  const [formData, setFormData] = useState({
    id: "",
    question: "",
    isSingleChoice: false,
    options: [],
    id: null,
  });

  const initialFormData = useMemo(
    () => ({
      id: "",
      question: "",
      isSingleChoice: false,
      options: [
        { name: "Option 1", index: 0 },
        { name: "Option 2", index: 1 },
        { name: "Option 3", index: 2 },
      ],
      id: null,
    }),
    []
  );

  useEffect(() => {
    if (eventData) {
      setFormData({
        id: eventData.id || "",
        isSingleChoice: eventData.isSingleChoice || false,
        question: eventData.question || "",
        options: eventData.options || [],
        id: eventData.id || null,
      });
    } else {
      setFormData(initialFormData);
    }
  }, [eventData, initialFormData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleOptionChange = (index, value) => {
    const newOptions = [...formData.options];
    newOptions[index] = { ...newOptions[index], name: value, index: index };
    setFormData({ ...formData, options: newOptions });
  };

  const handleAddOption = () => {
    setFormData((prev) => ({
      ...prev,
      options: [...prev.options, { name: "" }],
    }));
  };

  const handleRemoveOption = (index) => {
    const newOptions = [...formData.options];
    newOptions.splice(index, 1);
    setFormData({ ...formData, options: newOptions });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    setFormData(initialFormData);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">
            {eventData ? "Edit Poll" : "Create Poll"}
          </Typography>
          <div>
            <TextField
              id="question"
              label="Question"
              name="question"
              variant="outlined"
              type="text"
              fullWidth
              value={formData.question}
              onChange={(e) => handleChange(e)}
            />
          </div>

          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.isSingleChoice}
                  name="isSingleChoice"
                  onChange={(e) => handleChange(e)}
                />
              }
              label="Single Choice"
            />
          </div>
          <Typography variant="subtitle1" gutterBottom>
            Options
          </Typography>

          {formData.options.map((option, index) => (
            <div
              key={index}
              style={{ display: "flex", alignItems: "center", marginBottom: 8 }}
            >
              <Typography sx={{ mr: 2 }}>{index + 1}</Typography>
              <TextField
                label={`Option ${index + 1}`}
                value={formData.options[index]?.name || ""}
                onChange={(e) => handleOptionChange(index, e.target.value)}
                variant="outlined"
                fullWidth
              />
              <IconButton
                onClick={() => handleRemoveOption(index)}
                color="error"
                aria-label="Remove Option"
              >
                <DeleteIcon />
              </IconButton>
            </div>
          ))}

          {formData.options && formData.options.length < 4 && <Button variant="outlined" onClick={handleAddOption} fullWidth>
            + Add option
          </Button>}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          {eventData ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateEditPollModal;
